<template>
  <div class="animated fadeIn content-holder">
    <b-card no-body>
      <b-card-header class="custom-header">
        <div><i class="icon-note"></i> Customers Financial Reports{{ id ? " - Edit" : " - New"}}</div>
        <b-button-group>
          <router-link :to="`/customers/financialReports`" class="link">        
            <b-button class="custom-cancel"><i class="fa fa-times text-danger"></i>
               Cancel
            </b-button>
          </router-link>
          <b-button v-on:click="post('andClose')" :disabled="disabled || submitted"><i class="fa fa-save"></i> Save & Close</b-button>
          <b-button v-on:click="post()" :disabled="disabled"><i class="fa fa-check text-success "></i> Apply</b-button> 
          <b-button variant="" id="custom-button" @click="modalMergeOpen = true" v-b-popover.hover.top="'Merge'" >
            <i class="fa fa-star-half-full"></i> Merge
          </b-button> 
        </b-button-group>
      </b-card-header>

      <!-- Modal Component -->
      <div>
        <Modals ref="form"></Modals>
      </div>

      <b-card-body v-if="isLoading">
        <spinner></spinner> 
      </b-card-body>
      <b-card-body v-else>
        <b-row>
          
        <b-col  md="9" >
           <div> 
            <b-tabs>
              
              <!-- ### URL TAB ### -->
              <b-tab v-on:click="assignCurrentTab('0')" title="Core">
                  <b-card-body>
                <b-row>
                  <b-col md="2">
                    <!-- Sales Agent Name -->
                    <b-form-group label="Name Title" label-for="nameTitle">
                      <b-form-input id="nameTitle"
                        type="text"
                        v-model.lazy.trim="$v.form['nameTitle'].$model"
                        :state="chkState('nameTitle')"    
                        placeholder="Name Title"
                        autofocus />
                      <b-form-invalid-feedback>
                        This is a required field and must be at least 2 characters
                      </b-form-invalid-feedback>
                    </b-form-group> 

                  </b-col>      
                  <b-col md="5">
                    <!-- Sales Agent Name -->
                    <b-form-group label="First Name" label-for="nameFirstname">
                      <b-form-input id="nameFirstname"
                        type="text"
                        v-model.lazy.trim="$v.form['nameFirstname'].$model"
                        :state="chkState('nameFirstname')"    
                        placeholder="First Name"
                        autofocus />
                      <b-form-invalid-feedback>
                        This is a required field and must be at least 2 characters
                      </b-form-invalid-feedback>
                    </b-form-group> 

                  </b-col>                  
                  <b-col md="5">
                    <!-- Sales Agent Name -->
                    <b-form-group label="Last  Name" label-for="nameLastname">
                      <b-form-input id="nameLastname"
                        type="text"
                        v-model.lazy.trim="$v.form['nameLastname'].$model"
                        :state="chkState('nameLastname')"    
                        placeholder="Last Name"
                        autofocus />
                      <b-form-invalid-feedback>
                        This is a required field and must be at least 2 characters
                      </b-form-invalid-feedback>
                    </b-form-group> 

                  </b-col> 
                </b-row>                
                  <b-row>
                    <b-col md="12">
                    <!-- Email --> 
                    <b-form-group id="emailInputGroup4" label="Email" label-for="email">
                      <b-form-input id="Email"
                        type="email"
                        v-model.trim="$v.form.email.$model"
                        :state="chkState('email')"
                        aria-describedby="input1LiveFeedback4"
                        placeholder="Email"
                        autocomplete='email' />
                      <b-form-invalid-feedback id="input1LiveFeedback4">
                        This is a required field and must be valid e-mail address
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                    <b-col md="6">
                    <!-- Sales Agent Name -->
                    <b-form-group label="Company" label-for="company">
                      <b-form-input id="company"
                        type="text"
                        v-model.lazy.trim="$v.form['company'].$model"
                        :state="chkState('company')"    
                        placeholder="Company"
                        autofocus />
                      <b-form-invalid-feedback>
                        This is a required field and must be at least 2 characters
                      </b-form-invalid-feedback>
                    </b-form-group> 

                  </b-col>                  
                  <b-col md="6">
                    <!-- Sales Agent Name -->
                    <b-form-group label="Position" label-for="position">
                      <b-form-input id="position"
                        type="text"
                        v-model.lazy.trim="$v.form['position'].$model"
                        :state="chkState('position')"    
                        placeholder="Position"
                        autofocus />
                      <b-form-invalid-feedback>
                        This is a required field and must be at least 2 characters
                      </b-form-invalid-feedback>
                    </b-form-group> 

                  </b-col> 
                </b-row>
                
                <b-row>
                  <b-col md="12">
                    <!-- Sales Agent Address -->
                    <label>Sales Agent Address</label>
                    <b-form-group>
                      <b-form-input id="addressLine1"
                        type="text"
                        v-model.lazy.trim="$v.form.addressLine1.$model"
                        :state="chkState('addressLine1')"    
                        placeholder="Address 1"
                          />
                      <b-form-invalid-feedback>
                        This is a required field and must be at least 5 characters
                      </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group>
                      <b-form-input id="addressLine2"
                        type="text"
                        v-model.lazy.trim="$v.form.addressLine2.$model"
                        :state="chkState('addressLine2')"    
                        placeholder="Address 2"
                          />
                      <b-form-invalid-feedback>
                        This is a required field and must be at least 5 characters
                      </b-form-invalid-feedback>
                    </b-form-group>

                    <b-row>
                      <b-col md="6">
                        <b-form-group label="Country" label-for="addressCountry">
                          <b-form-select id="addressCountry" label="Country" class="form-group"
                            :plain="true"
                            :options="this.countryListOptions"
                            v-model.lazy.trim="$v.form.addressCountry.$model"
                            :state="chkState('addressCountry')"  
                            value="Please select a country">
                          </b-form-select>   
                          <b-form-invalid-feedback>
                            This is a required field and must be at least 2 characters
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                      <b-col md="6">
                        <!-- State -->
                        <b-form-group label="State" label-for="addressState">
                          <b-form-input id="addressState"
                            type="text"
                            v-model.lazy.trim="$v.form.addressState.$model"
                            :state="chkState('addressState')"    
                            placeholder="State"
                              />
                          <b-form-invalid-feedback>
                            This is a required field and must be at least 2 characters
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col md="6">                      
                        <b-form-group label="Zip Code" label-for="addressZipcode">
                          <b-form-input id="addressZipcode"
                            type="text"
                            v-model.lazy.trim="$v.form.addressZipcode.$model"
                            :state="chkState('addressZipcode')"    
                            placeholder="Zip Code"
                          />
                          <b-form-invalid-feedback>
                            This is a required field and must be at least 2 characters
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                      <b-col md="6">
                        <!-- City -->
                        <b-form-group label="City" label-for="addressCity">
                          <b-form-input id="addressCity"
                            type="text"
                            v-model.lazy.trim="$v.form.addressCity.$model"
                            :state="chkState('addressCity')"    
                            placeholder="City"
                          />
                          <b-form-invalid-feedback>
                            This is a required field and must be at least 2 characters
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <!--Start Custom Core Field  -->
                 <div v-for="coreField in coreCustomfields " :key="coreField.index">
                   <b-form-group :label="`${coreField.label}`" :label-for="`${coreField.alias}`">
                      <b-form-input :id="`${coreField.alias}`"
                        :type="`${coreField.data_type}`"
                        v-model.lazy.trim="coreField.value"
                      />
                      <b-form-invalid-feedback>
                        This is a required field and must be at least 7 characters
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </div>
                 <!--End Custom Core Field  -->
                   

                  </b-col>
                </b-row>
              </b-card-body>

              </b-tab>

              <!-- ### TEXT TAB ### -->
              <b-tab v-on:click="assignCurrentTab('1')" title="Social">
                <!--Start Custom Social Field  -->
                 <div v-for="socialField in socialCustomfields " :key="socialField.index">
                   <b-form-group :label="`${socialField.label}`" :label-for="`${socialField.alias}`">
                      <b-form-input :id="`${socialField.alias}`"
                        :type="`${socialField.data_type}`"
                        v-model.lazy.trim="socialField.value"
                      />
                      <b-form-invalid-feedback>
                        This is a required field and must be at least 7 characters
                      </b-form-invalid-feedback>
                    </b-form-group> 
                  </div>
                 <!--End Custom Social Field  -->
              </b-tab>
              
            </b-tabs>

          </div>
          </b-col>
          <b-col md="3">
            <b-card>
              <h2>sdvdsvds</h2>
            </b-card>

          </b-col>
           
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import Vue from 'vue';
import VueNotifications from 'vue-notifications';
import miniToastr from 'mini-toastr';
import { validationMixin } from "vuelidate";
import { required, minLength, email, sameAs, helpers, url, alpha } from "vuelidate/lib/validators";
import { Switch as cSwitch } from '@coreui/vue';
import { router } from '../../router/index';
import { mapState, mapActions } from 'vuex';
import { apigClient } from '@/shared/api';
import { cipher } from '@/shared/cipher';
import { userPool } from '@/shared/cognito';
import { timezones } from '@/shared/helper';
import { countryList } from '@/shared/helper';
import Modals from "@/shared/Modals.vue";

const Spinner = () => import('../shared/Spinner');
const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}
miniToastr.init({types: toastTypes})
function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}
const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}
Vue.use(VueNotifications, options);
var tzList = timezones.tz.names().map((elem, index)=>{
  return {name:elem, id:index};
});
const formShape = {
  // customFields: "",
  accountName: "",
  exportFinancial: "",
}
  let validations = {
  form: {
    // customFields:{
    // },
    platformType: {
      required: false,
    },
    addressLine1: {
      required,
      minLength: minLength(5)
    },
    addressLine2: {},
    addressCity:{},
    addressState:{},
    addressZipcode:{},
    addressCountry:{},
    phone:{},
    birthday:{},
    nameTitle: {
      required,
      minLength: minLength(2)
    },
    nameFirstname: {
      required,
      minLength: minLength(2)
    },
    nameLastname: {
      required,
      minLength: minLength(2)
    },
     email: {
      email
    },
     company: {
    },
     position: {
    },
  }
}
export default {
  name: "SalesAgent",
  components: {
    cSwitch,
    Spinner,
    Modals
  },
  data() {
    if(window.location.href.includes("/customers/financialReports/edit")){
      var id = localStorage.getItem('page_financialReports_id');
    }
    return {
      socialCustomFieldsModel: [],
      coreCustomFieldsModel: [],
      loginUserInfo: JSON.parse(localStorage.getItem('loginUserInfo')),
      title:'',
      form: Object.assign({}, formShape),
      feedBack: 'secondary',
      submitted: false,
      disabled: true,
      isLoading: true,
      selectedForm: 'basicInfo',
      modalMergeOpen: false,
      countryListOptions: countryList,
      id:id||null,
      coreCustomfields:[],
      socialCustomfields:[],
      customFields:[],
    }
  },
  
  created: function() {
    
  },
  
  mounted: function(){
    var that = this;
    // this.getUsersData();
    this.loadCustomFields();
    that.form.platformType = this.platformTypeSelected;
    that.form.fullDomainName = this.platformTypeSelected === 'full white-label' ? 'https://' : this.fullDomainNameTmp;
    if (this.id){
      this.getClientsData();
    } 
  },
  computed: {
    formStr() { return JSON.stringify(this.form, null, 4) },
    isValid() { return !this.$v.form.$anyError },
    isDirty() { return this.$v.form.$anyDirty },
  },
  mixins: [validationMixin],
  validations: validations,
  methods: {
  post:function(option){
       
      //start  Push value custom field to arrar
      this.socialCustomfields.forEach(scf => {
        let field = {"alias":scf.alias,"value":scf.value || null};
        //  field[scf.alias] = scf.value || null
         this.customFields.push(field)
      });

      this.coreCustomfields.forEach(ccf => {
        let field = {"alias":ccf.alias,"value":ccf.value || null};
        //  field[ccf.alias] = ccf.value|| null
        this.customFields.push(field);
        
      });
      //end  Push value custom field to arrar
      var that = this; 
      if(that.errors.count() > 0){
        return;
      }
      this.isLoading = true;
      let nodata = null;
      var body = {
            nameTitle: that.form.nameTitle || nodata,
            nameFirstname: that.form.nameFirstname || nodata,
            nameLastname: that.form.nameLastname || nodata,
            email: that.form.email || nodata,
            company: that.form.company || nodata,
            addressLine1: that.form.addressLine1 || nodata,
            addressLine2: that.form.addressLine2 || nodata,
            addressCity: that.form.addressCity || nodata,
            addressZipcode: that.form.addressZipcode || nodata,
            addressState: that.form.addressState || nodata,
            addressCountry: that.form.addressCountry || nodata,
            customFields: that.customFields || nodata,
      };
      if(false) {
      } else {
        if(this.salesAgent_id){
        this.$refs.form.openModal();
        that.changeModalContent(
          "loading",
          "Updating...",
          "Updating Financial Info"
        );
          var method = 'PUT';
          var pathTemplate = '/financialReports/' + this.id;
          var additionalParams ={};
          var pathParams = {};
          apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams, body)
            .then(function(result){
              if (result.data.status) {
                // that.showSuccessMsgUpdate();
                if ( option == "andClose" ){
                  that.changeModalContent(
                    "success",
                    "Updated success!",
                    "The Financial data has been updated"
                  );
                  setTimeout(() => {
                  router.push(`/customers/financialReports`);
                  }, 2000)  
              } else {
                // that.showErrorMsg({message: result.data.message});
                // Apply
                setTimeout(() => {
                  that.changeModalContent(
                    "success",
                    "Updated success!",
                    "The Financials data has been updated"
                  );
                  setTimeout(() => {
                    that.$refs.form.closeModal();
                  }, 2000);
                }, 2000);
              }
              } else {
              that.changeModalContent(
                "error",
                "Error Occured!",
                "Error From API Endpoint: " + result.data.message
              );
            }
            }).catch( function(result){
              // that.showErrorMsg({message: result.message});
              that.changeModalContent(
                "error",
                "Error Occured!",
                "invokeAPI Error: " + result.message
              );
            });
        } else {
          this.$refs.form.openModal();
          var method = 'POST';
          var pathTemplate = '/financialReports';
          var additionalParams ={
          };
          var pathParams = {
          };
          apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams, body)
            .then(function(result){
              if (result.data.status) {
                // that.showSuccessMsgCreate();    
                if (option == "andClose") {
                  that.changeModalContent(
                    "success",
                    "Saved success!",
                    "The Financial data has been created"
                  );
                  localStorage.setItem('page_financialReports_id', result["data"]["data"]);
                  setTimeout(() => {
                    router.push(`/customers/financialReports`);
                  }, 2000)  
              } else {
                // Apply
                that.changeModalContent(
                  "success",
                  "Saved success!",
                  "The Financial data has been updated"
                );
                setTimeout(() => {
                  that.$refs.form.closeModal();
                }, 2000);
              }
              } else {
                // that.showErrorMsg({message: result.data.message});
                that.changeModalContent(
                  "error",
                  "Error Occured!",
                  "Error From API Endpoint: " + result.data.message
                );
              }       
            }).catch( function(result){
              // that.showErrorMsg({message: result.message});
              that.changeModalContent(
                "error",
                "Error Occured!",
                "invokeAPI Error: " + result.message
              );
            });
          }
        }
      this.isLoading = false;
    },
    changeModalContent(status = null, title = null, message = null) {
      let that = this;
      that.$refs.form.status = status ? status : that.$refs.form.status;
      that.$refs.form.title = title ? title : that.$refs.form.title;
      that.$refs.form.message = message ? message : that.$refs.form.message;
    },
    routerBack(){
      this.$router.go(-1);
    },
    onSubmit() {
      if (this.validate() ) {
        this.$nextTick(() => {
          // submit
          this.submitted = true
          this.feedBack = 'info'
        })
      }
    },
    onReset() {
      // Reset validation
      this.form = Object.assign({}, formShape)
      this.submitted = false
      this.$nextTick(() => {
        this.$v.$reset()
        this.feedBack = 'secondary'
      })
    },
    chkState(val) {
      const field = this.$v.form[val];
      let name = this.$v.form["nameFirstname"];
      let addressLine1 = this.$v.form["addressLine1"];
      let addressCountry = this.$v.form["addressCountry"];
      let addressZipcode = this.$v.form["addressZipcode"];
      let addressCity = this.$v.form["addressCity"];
       let basicFieldsInvalid = (name.$model !==undefined && name.$model !== '')
      this.disabled = !basicFieldsInvalid;
      return (field.$model !== '' && field.$model !== undefined) ? !field.$dirty || !field.$invalid : null;
    },
    findFirstError(component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })
      return focused
    },
    validate() {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid;
    },
    loadCustomFields: function() {
        var method = 'GET';
        var pathTemplate = '/customFields/wallet/Client';
        var additionalParams ={};
        var pathParams = {};
        var that = this;
        apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams)
          .then(function(result) {
            let response = result.data;
              let data = response.data.map((elem, index) => {
                elem.index = index
                switch (elem.group) {
                  case 'Social':
                 that.socialCustomfields.push(elem);
                    break;
                  case 'Core':
                   that.coreCustomfields.push(elem);
                    break;
                  default:
                    console.log('error');
                    break;
                }
              });
              that.isLoading = false;
          }).catch( function(error){
            console.log(error)
            that.isLoading = false;
          });
      },
      getClientsData:function(){
      let method = 'GET';
      let pathTemplate = '/financialReports/'+this.id;
      let additionalParams ={};
      let pathParams = {};
      let salesAgentData = [];
      let that = this;
      apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(result){
          if (result.data.status) {
            var datas = result["data"]["data"];
            that.form.nameTitle = datas.nameTitle;
            that.form.nameFirstname = datas.nameFirstname;
            that.form.nameLastname = datas.nameLastname;
            that.form.email = datas.email;
            that.form.company = datas.company;
            that.form.addressLine1 = datas.addressLine1;
            that.form.addressLine2 = datas.addressLine2;
            that.form.addressCity = datas.addressCity;
            that.form.addressZipcode = datas.addressZipcode;
            that.form.addressState = datas.addressState;
            that.form.addressCountry = datas.addressCountry;

            datas.customFields.forEach(fields => {
              that.socialCustomfields.forEach(scf => {
                if(scf.alias == fields.alias){
                scf.value = fields.value;
                }
              }); 
            }); 
          
            //This is where you would put a success callback
            that.isLoading = false;
          } else {
            that.showErrorMsg({message: result.data.message});
            that.isLoading = false;
          }
      }).catch( function(error){
        that.showErrorMsg({message: error.message});
        that.isLoading = false;
        //This is where you would put an error callback
      });
      },
     assignCurrentTab(value){
      this.currentTab = value;
      // console.log(this.currentTab);
    },
  },
  notifications: {
    showSuccessMsgCreate: {
      type: VueNotifications.types.success,
      title: 'Operation successfull!',
      message: 'The Sales Agent data has been create'
    },
    showSuccessMsgUpdate: {
      type: VueNotifications.types.success,
      title: 'Operation successfull!',
      message: 'The Sales Agent data has been update'
    },
    showInfoMsg: {
      type: VueNotifications.types.info,
      title: 'Info',
      message: 'Here is some info for you'
    },
    showWarnMsg: {
      type: VueNotifications.types.warn,
      title: 'Warning',
      message: 'That\'s the kind of warning'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: null,
      message: ''
    }
  },
}
</script>



<style scoped>
  .btn.disabled {
    cursor: auto;
  }
  .custom-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .btn-group > .btn, .btn-group-vertical > .btn {
      border: 1px solid #a4acb5;
  }
  @media only screen and (max-width: 600px) {
    .custom-header{
      flex-direction: column;
      align-items: inherit;
    }
    .custom-header > div:first-child {
      margin-bottom: 10px;
    } 
  }
  .custom-cancel {
    border-radius: 0.25rem 0 0 0.25rem;
  }
  .sk-fading-circle .sk-circle {
    margin: 0 auto;
  }
  .sk-three-bounce {
    height: 40px;
  }
  label {
    font-weight: 600!important;
  }
</style>

<style>
  #language {
    margin-top: 15px;
  }
  .custom-header{
    display: flex;
    justify-content: space-between;
  } 
  select {
    /* for Firefox */
    -moz-appearance: none;
    /* for Chrome */
    -webkit-appearance: none;
  }
  /* For IE10 */
  select::-ms-expand {
    display: none;
  }
  .tech-image{
    height:15px;
  }
  .form-group label.required:after {
    content: " *";
    color: #f86b4f;
  }
  .color-20a8d8{
    color:#20a8d8;
  }
  .underline{
    text-decoration: underline;
  }
  .font-size-13{
    font-size:13px !important;
  }
  .color-red{
    color:red;
  }
  .margin-bottom-5{
    margin-bottom: 5px;
  }
</style>